// import PropTypes from 'prop-types';
import {PureComponent} from 'react';
import ContentWrapper from 'Component/ContentWrapper';
import {HistoryType} from 'Type/Common';

import './SpecialOffers.style';
import PropTypes from "prop-types";
import {BLOG_CATEGORY_LISTING} from "../../../route/CategoryListing/CategoryListing.config";
import SpecialOffersBlogPostCard from "./SpecialOffersBlogPostCard";
import SpecialOffersFilters from "./SpecialOffersFilters";
import CategoryPagination from 'Component/CategoryPagination';
import { getQueryParam, setQueryParams } from 'Util/Url';
import Html from "Component/Html";

export class SpecialOffers extends PureComponent {

    static propTypes = {
        updateBreadcrumbs: PropTypes.func.isRequired,
        updateMeta: PropTypes.func.isRequired,
        history: HistoryType.isRequired,
        setHeaderState: PropTypes.func.isRequired,
        isLoaded: PropTypes.bool,
        pageSize: PropTypes.number.isRequired,
        posts: PropTypes.shape({
            items: PropTypes.array,
            total_pages: PropTypes.number,
            count: PropTypes.number
        }).isRequired,
        categories: PropTypes.shape({
            items: PropTypes.array,
            count: PropTypes.number
        }).isRequired,
        category: PropTypes.string.isRequired,
        loadMore: PropTypes.func.isRequired
    };

    static defaultProps = {
        isLoaded: false
    };

    state = {
        collapsTab : [],
        customFilters : {}
    }

    componentDidMount() {
        this.updateMeta();
        this.setHeaderState();
        this.updateBreadcrumbs();
        this.processCustomFilters();
    }

    processCustomFilters() {
        let customFilters = this._getSelectedFiltersFromUrl();
        this.setState({
            customFilters : customFilters
        });
        this.requestPosts(customFilters )
    }

    requestPosts(customFilters){
        const { requestPosts, category_id } = this.props;
        let filter = Object.entries(customFilters).reduce((
            arr , data
        )=>{
            if(data[1].length){
                if(!arr.filter.or){
                    arr.filter.or = {};
                }
                arr.filter.or[data[0]] = { in : data[1] }
            }
            return arr;
        },{ filter : { category_id : {eq : category_id }  }, isSpeacialOffer : true });
        requestPosts(filter);
    }


    filterOptionClick(value,fieldCode){
        const { location, history } = this.props;
        let {customFilters} = this.state;
        if(customFilters[fieldCode] && customFilters[fieldCode].length){
            if(customFilters[fieldCode].includes(value)){
                const index = customFilters[fieldCode].indexOf(value);
                if (index > -1) {
                    customFilters[fieldCode].splice(index, 1);
                }
            }else {
                customFilters[fieldCode].push(value);
            }
        }else {
            customFilters[fieldCode] = [value]
        }
        setQueryParams({
            customFilters: this.getFilterUrl(fieldCode, customFilters[fieldCode], false),
            page: ''
        }, location, history);
        this.requestPosts(customFilters)
        this.setState({customFilters : customFilters});
    }
    resetAllFilters(value,fieldCode){
        const { location, history } = this.props;
        setQueryParams({
            customFilters: {},
            page: ''
        }, location, history);
        this.requestPosts({})
        this.setState({customFilters : {}});
    }

    getFilterUrl(filterName, filterArray, isFull = true) {
        const { location: { pathname } } = this.props;
        const selectedFilters = this._getNewSelectedFiltersString(filterName, filterArray);
        const customFilters = isFull ? `${pathname}?customFilters=` : '';
        const formattedFilters = this._formatSelectedFiltersString(selectedFilters);

        return `${ customFilters }${ formattedFilters }`;
    }

    _formatSelectedFiltersString(string) {
        const hasTrailingSemicolon = string[string.length - 1] === ';';
        const hasLeadingSemicolon = string[0] === ';';

        if (hasLeadingSemicolon) {
            return this._formatSelectedFiltersString(string.slice(0, -1));
        }

        if (hasTrailingSemicolon) {
            return string.slice(1);
        }

        return string;
    }

    _getSelectedFiltersFromUrl() {
        const { location } = this.props;
        const selectedFiltersString = (getQueryParam('customFilters', location) || '').split(';');

        return selectedFiltersString.reduce((acc, filter) => {
            if (!filter) {
                return acc;
            }
            const [key, value] = filter.split(':');

            return { ...acc, [key]: value.split(',') };
        }, {});
    }

    _getNewSelectedFiltersString(filterName, filterArray) {
        const prevCustomFilters = this._getSelectedFiltersFromUrl();
        const customFilers = {
            ...prevCustomFilters,
            [filterName]: filterArray
        };

        return Object.entries(customFilers)
            .reduce((accumulator, [filterKey, filterValue]) => {
                if (filterValue.length) {
                    const filterValues = filterValue.sort().join(',');

                    accumulator.push(`${filterKey}:${filterValues}`);
                }

                return accumulator;
            }, [])
            .sort()
            .join(';');
    }

    toggleExpandableContent(fieldCode){
        let { collapsTab } = this.state;
        if(collapsTab.includes(fieldCode)){
            const index = collapsTab.indexOf(fieldCode);
            if (index > -1) {
                collapsTab.splice(index, 1);
            }
        }else {
            collapsTab.push(fieldCode)
        }
        this.setState({ collapsTab : [...collapsTab] })
    }

    updateBreadcrumbs() {
        const {updateBreadcrumbs, mfblog_permalink_route, categoryObject : { title }, blog_title } = this.props;
        const breadcrumbs = [
            ...this.getCategoryBreadcrumb(),
            {
                url: window.location.pathname,
                name: title
            },
            {
                url: `/${mfblog_permalink_route}`,
                name: blog_title
            }
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    updateMeta() {
        const {updateMeta, redirect_code_previous, categoryObject : _category} = this.props;

        updateMeta({
            title: _category.title,
            meta_title : _category.meta_title,
            meta_keywords : _category.meta_keywords,
            meta_description : _category.meta_description,
            canonical_url: window.location.href,
            redirect_from: window.location.pathname,
            redirect_code_previous
        });
    }

    getDefaultTitle() {
        const {title} = this.props;

        if (title) {
            return title;
        }

        return __('HC INSIDER')
    }

    renderTitle() {
        return (
            <h1 block="CategoryListing" elem="Title">
                {this.getCategoryTitle() || this.getDefaultTitle()}
            </h1>
        );
    }

    /**
     * Gets the canonical url for the specific post
     */
    getCanonicalUrl() {
        return window.location.href;
    }

    getCategoryTitle() {
        const {category, categories: {items}} = this.props;
        const {title} = items.find(({identifier}) => identifier === category) || {};

        return title;
    }

    getCategoryDescription() {
        const {meta_description} = this.props;

        if (!meta_description)
            return (
                <div
                    className="CategoryListing-Description">{__('Experience ΗΟNDOS CENTER  at one of our three Θεσσαλονίκη stores. Showcasing an edit of our 650+ established and emerging menswear and womenswear designers, each store is a uniquely curated beauty & fashion destination.')}</div>
            );

        return (
            <div className="CategoryListing-Description">{meta_description}</div>
        );
    }

    getCategoryBreadcrumb() {
        const {categories: {count}, category} = this.props;
        const title = this.getCategoryTitle() || '';

        if (count && title) {
            return [
                {
                    name: title
                }
            ];
        }

        if (!count && category) {
            return [
                {
                    name: ''
                }
            ];
        }

        return [];
    }

    setHeaderState() {
        const {setHeaderState, history} = this.props;
        setHeaderState({
            name: BLOG_CATEGORY_LISTING,
            title: 'Blog',
            onBackClick: () => history.goBack()
        });
    }

    renderCmsBlockPromoListing() {
        const { categoryObject : { listing_block } } = this.props;

        if(listing_block) {
            return <div className="SpecialOffers-Promo"><Html content={listing_block}/></div>
        }

        return null
    }

    renderGrid() {
        const {
            isLoaded,
            posts: {items},
            pageSize,
            categoryFilterOptionsArrays,
            categoryFilter
        } = this.props;

        if (isLoaded && items.length) {
            return items.map((post, i) => {
                if(i == 3) {
                    return (
                        <>
                            { this.renderCmsBlockPromoListing() }
                            <SpecialOffersBlogPostCard
                                key={post.post_id}
                                block="BlogPostCard"
                                post={post}
                                categoryFilterOptionsArrays={categoryFilterOptionsArrays}
                                categoryFilter={categoryFilter}
                            />
                        </>
                    );
                }

                return (
                    <SpecialOffersBlogPostCard
                        key={post.post_id}
                        block="BlogPostCard"
                        post={post}
                        categoryFilterOptionsArrays={categoryFilterOptionsArrays}
                        categoryFilter={categoryFilter}
                    />
                );
            });
        }

        if (isLoaded) {
            return (
                <span>
                    {__('No posts in this category')}
                </span>
            );
        }

        return Array.from({length: pageSize}, (_, i) => (
            <SpecialOffersBlogPostCard
                key={i}
                block="BlogPostCard"
                isPlaceholder
            />
        ));
    }

    requestPage(){
        let customFilters = this._getSelectedFiltersFromUrl();
        const { requestPosts, category_id, requestPage } = this.props;
        let filter = Object.entries(customFilters).reduce((
            arr , data
        )=>{
            if(data[1].length){
                if(!arr.filter.or){
                    arr.filter.or = {};
                }
                arr.filter.or[data[0]] = { in : data[1] }
            }
            return arr;
        },{ filter : { category_id : {eq : category_id }  }, isSpeacialOffer : true });
        requestPage(filter);
    }

    renderPagination() {
        const {
            isLoading,
            posts: {
                total_pages: totalPages
            },
            requestPage
        } = this.props;

        return (
            <CategoryPagination
                isLoading={isLoading}
                totalPages={totalPages}
                onPageSelect={this.requestPage.bind(this)}
            />
        );
    }

    renderLoadMore() {
        const {posts: {count}, pageSize, loadMore} = this.props;

        if (count <= pageSize) {
            return null;
        }

        return (
            <div block="CategoryListing" elem="LoadMoreWrapper">
                <button
                    block="CategoryListing"
                    elem="LoadMoreButton"
                    mix={{block: 'Button'}}
                    onClick={loadMore}
                >
                    {__('Load More')}
                </button>
            </div>
        );
    }

    render() {
        const {categoryFilter, location, history, requestPosts, category_id} = this.props;
        const { customFilters, collapsTab  } = this.state;

        return (
            <main block="CategoryListing" className={'SpecialOffersListing'}>
                <ContentWrapper label="CategoryListing">
                    {this.renderTitle()}
                    {this.getCategoryDescription()}
                    <div block="CategoryListing" elem="ColumnWrapper">
                        <div block="CategoryListing" elem="Sidebar" className="CategoryFilterOverlay SpecialOffersFilterOverlay">
                            <div className="CategoryFilterOverlay-Attributes">
                                <SpecialOffersFilters
                                    categoryFilter={categoryFilter}
                                    location={location}
                                    history={history}
                                    requestPosts={requestPosts}
                                    category_id={category_id}
                                    customFilters={customFilters}
                                    collapsTab={collapsTab}
                                    toggleExpandableContent={this.toggleExpandableContent.bind(this)}
                                    filterOptionClick={this.filterOptionClick.bind(this)}
                                    resetAllFilters={this.resetAllFilters.bind(this)}
                                />
                            </div>
                        </div>
                        <div block="CategoryListing" elem="Grid">
                            {this.renderGrid()}
                        </div>
                        <div>
                            { this.renderPagination() }
                        </div>
                    </div>
                </ContentWrapper>
            </main>
        );
    }
}

export default SpecialOffers;
